import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import userService from '../../app/services/user.service';
import { Row, Col } from 'react-bootstrap';
import classes1 from '../../Components/Questions/Questions.module.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PrintView = () => {
  const query = useQuery();
  const uid = query.get('uid');
  const sid = query.get('sid');
  const pid = query.get('pid');
  const [qData, setQData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid || !sid || !pid) return;
    userService.getViewPaper({ uid, sid, pid })
      .then(data => {
        setQData(data.data);
        setLoading(false);
      });
  }, [uid, sid, pid]);

  useEffect(() => {
    if (qData) {
      setTimeout(() => window.print(), 500);
    }
  }, [qData]);

  // Helper function to check if Hindi content is available
  const hasHindiContent = (data) => {
    const hindiQuestion = data.q_text_hindi && 
      data.q_text_hindi.trim() !== '' && 
      data.q_text_hindi !== '<html>\n<head>\n\t<title></title>\n</head>\n<body></body>\n</html>';
    
    const hindiOptions = data.h_option && 
      data.h_option.trim() !== '' && 
      data.h_option !== '<html>\n<head>\n\t<title></title>\n</head>\n<body></body>\n</html>';
    
    return hindiQuestion || hindiOptions;
  };

  // Helper function to render question content
  const renderQuestionContent = (data, isHindi = false) => {
    const questionText = isHindi ? data.q_text_hindi : data.q_text;
    const optionsText = isHindi ? data.h_option : data.eng_option;
    
    return (
      <div className={classes1["sec-card1"]} style={{padding:12}}>
        <b>Question {data.qno} : </b>
        <span dangerouslySetInnerHTML={{__html: questionText}} />
        {optionsText && (
          <ol style={{ listStyleType: "upper-alpha", marginLeft: "30px" }}>
            {[...new Set(optionsText.split("@@@"))]?.map((opt, i) => (
              <li key={i}><div dangerouslySetInnerHTML={{__html: opt}} /></li>
            ))}
          </ol>
        )}
      </div>
    );
  };

  if (!uid || !sid || !pid) {
    return <div className="text-center mt-5"><h4>Missing Required Parameters</h4></div>;
  }
  if (loading || !qData) return <div>Loading...</div>;

  return (
    <div className="printable" style={{ padding: 32, paddingLeft: 16 }}>
      <style>
        {`
          @media print {
            .bilingual-container {
              display: flex !important;
              flex-direction: row !important;
              gap: 16px !important;
              margin-bottom: 8px !important;
            }
            .english-content {
              flex: 1 !important;
              min-width: 45% !important;
              padding-right: 8px !important;
            }
            .hindi-content {
              flex: 1 !important;
              min-width: 45% !important;
              padding-left: 8px !important;
            }
            .row {
              display: flex !important;
              flex-wrap: nowrap !important;
            }
            .col-md-6 {
              flex: 0 0 50% !important;
              max-width: 50% !important;
            }
          }
        `}
      </style>
      <h2 className="text-center mb-3">Question Paper</h2>
      <div className="mb-3" style={{paddingLeft: 16}}>
       
          <Col md={12} sm={12}><b>Paper Code:</b> {qData?.paper_info?.paper_id}</Col>
          <Col md={12} sm={12}><b>Format:</b> {qData?.paper_info?.paper_format}</Col>
          <Col md={12} sm={12}><b>Exam Date:</b> {qData?.paper_info?.to_be_held_on}</Col>
          <Col md={12} sm={12}><b>Questions Assigned:</b> {qData?.paper_info?.creator}</Col>
          <Col md={12} sm={12}><b>Date Of Submission:</b> {qData?.paper_info?.to_be_completed_by}</Col>
          <Col md={12} sm={12}><b>Center:</b> {qData?.paper_info?.centers}</Col>
          {qData?.paper_info?.topic_names && <Col md={12} sm={12}><b>Syllabus:</b> {qData?.paper_info?.topic_names}</Col>}
          {qData?.paper_info?.remarks && <Col md={12} sm={12}><b>Remarks:</b> {qData?.paper_info?.remarks}</Col>}
        
      </div>
      
      <div className="print-questions" style={{padding: 32}}>
        {qData?.paper_matrix && Object.values(qData?.paper_matrix)?.map((data, index) => {
          const showBilingual = hasHindiContent(data);
          
          return (
            <div key={index} className="mb-4">
              {/* Question Metadata */}
              <div className={classes1["sec-card"]} style={{marginBottom: 8}}>
                <b>Qid:</b> {data.qid}
              </div>
              <div className={classes1["sec-card"]} style={{marginBottom: 8}}>
                <b>Topic:</b> {data.topic_name}
              </div>
              <div className={classes1["sec-card"]} style={{marginBottom: 8}}>
                <b>Sub-topic:</b> {data.sub_topic_name}
              </div>
              <div className={classes1["sec-card"]} style={{marginBottom: 8}}>
                <b>Toughness:</b> {data.toughness}
              </div>
              
              {/* Question Content */}
              {showBilingual ? (
                <div className="bilingual-container">
                  {/* English Content - Left Side */}
                  <div className="english-content">
                    {renderQuestionContent(data, false)}
                  </div>
                  
                  {/* Hindi Content - Right Side */}
                  <div className="hindi-content">
                    {renderQuestionContent(data, true)}
                  </div>
                </div>
              ) : (
                // Single language display when Hindi is not available
                renderQuestionContent(data, false)
              )}
              
              {/* Answer */}
              <p className={classes1["crct-ans-opt"]}>
                Answer: <span>{data.answer}</span>
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PrintView;